import { useMutation } from '@tanstack/vue-query';

import inactiveAccountsService from '../services/inactiveAccountsService';
import { InactiveAccounts } from "~/types/equipment"

export default function useBatchProcessAccounts() {
  return useMutation({
    mutationFn: async (params: InactiveAccounts.BatchProcessAccountsRequest) => {
      const res = await inactiveAccountsService.batchProcess(params);
      return res;
    },
  });
}
